import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

function validateCPFInternal(cleanCpf: string): boolean {
  if (/^(\d)\1{10}$/.test(cleanCpf)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
  }
  let remainder = sum % 11;
  const firstDigit = remainder < 2 ? 0 : 11 - remainder;

  if (parseInt(cleanCpf.charAt(9)) !== firstDigit) {
    return false;
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
  }
  remainder = sum % 11;
  const secondDigit = remainder < 2 ? 0 : 11 - remainder;

  if (parseInt(cleanCpf.charAt(10)) !== secondDigit) {
    return false;
  }

  return true;
}

export const cpfValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }

  const cpf = String(control.value);
  const cleanCpf = cpf.replace(/\D/g, '');

  if (cleanCpf.length !== 11) {
    return { invalidLength: true };
  } else if (!validateCPFInternal(cleanCpf)) {
    return { invalidCpf: true };
  }
  return null;
};
